<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expanded-keys="dataIdArr"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="20" style="margin-bottom: 15px">
          <student-list ref="studentList" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import studentList from './student-list';
  import { finiteDataTree } from '@/config/api'; //获取老师所负责的班级树

  export default {
    name: 'StudentList',
    components: { studentList },
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        // current: null,  // 选中数据
        dataIdArr: [],
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      query() {
        this.loading = true;
        finiteDataTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData = res.data.data;
              this.$refs.studentList.ClassTree = res.data.data;
              this.dataIdArr = this.$util.getTreeFloor(this.deptData, 1, this.dataIdArr, 'id');
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },

      /* 选择数据 */
      choose(row) {
        if (row.orgType === 4) {
          this.$refs.orgTree.setCurrentKey(row.id);
          let obj = {
            classId: row.id.slice(1),
          };
          // console.log(this.$refs);
          this.$refs.studentList.classId = row.id.slice(1);
          this.$refs.studentList.queryClassName(row.id.slice(1));
          this.$refs.studentList.table.where = obj;
          this.$refs.studentList.$refs.table.reload();
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
